export const EMPTY_FIELD = '\u2013';
